<template>
  <OButton
    size="lg"
    primary
    icon="svguse:#icon_search"
    class="sm:w-full"
    icon-size="1.5rem"
    label="Comparar com"
  >
    <q-menu
      ref="popup"
      class="overflow-x-hidden border border-neutral-100/10 shadow-xl w-full max-w-[93rem] overflow-y-hidden"
      anchor="top right"
      self="top right"
      @show="loadItems"
    >
      <OInput
        v-model="search"
        debounce="400"
        label="Comparar com"
        size="md"
        clearable
      >
        <template v-slot:prepend>
          <q-icon
            name="svguse:#icon_search"
            size="1.5rem"
            class="text-neutral-70"
          />
        </template>
      </OInput>

      <div class="flex gap-8 px-16 pt-16 pb-8">
        <button
          v-for="(_filter, _index) in filters"
          :key="_index"
          class="text-paragraph-3 text-neutral-70 px-10 h-24 rounded-md border border-[#E7E8E9] bg-white transition"
          :class="[
            _filter === activeFilter
              ? '!border-primary-pure !bg-primary-pure/10 text-primary-pure !text-headline-3'
              : 'hover:brightness-95',
            isFilterDisabled(_filter)
              ? 'opacity-50 cursor-not-allowed'
              : '',
          ]"
          :disabled="isFilterDisabled(_filter)"
          @click="activeFilter = _filter"
        >
          {{ _filter }}
        </button>
      </div>

      <div class="flex items-center gap-8 h-32 px-16">
        <h4 class="text-headline-4 text-neutral-70">
          Sobre essas sugestões
        </h4>

        <q-icon
          name="svguse:#icon_info_circle"
          size="1.125rem"
          class="text-neutral-70 cursor-pointer"
        >
          <q-tooltip
            anchor="center right"
            self="center left"
            class="bg-[#202227] text-[#9F9FA0] p-12"
          >
            Pode adicionar até 5 comparações.
          </q-tooltip>
        </q-icon>
      </div>

      <q-list class="overflow-y-auto max-h-[20rem]">
        <q-item
          v-if="filterModel.zona || filterModel.fabricante"
          clickable
          class="flex items-center gap-8 py-0 px-16 h-40 text-headline-3 text-neutral-70 !font-normal"
          @click="handleAddComparisonBest('Melhor da região')"
        >
          <q-icon
            name="svguse:#icon_map_point_pin"
            size="1.25rem"
            class="text-primary-pure"
          />
          <span> Melhor da Região </span>
        </q-item>

        <q-item
          clickable
          class="flex items-center gap-8 py-0 px-16 h-40 text-headline-3 text-neutral-70 !font-normal"
          @click="handleAddComparisonBest('Melhor do tier')"
        >
          <q-icon
            name="svguse:#icon_security_shield"
            size="1.25rem"
            class="text-primary-pure"
          />
          <span> Melhor do Tier </span>
        </q-item>

        <q-item
          v-if="filtersLoading"
          class="flex items-center gap-8 py-0 px-16 h-40 border-t border-neutral-100/10 text-headline-3 text-neutral-40 !font-normal pointer-events-none"
        >
          <q-spinner-tail color="primary" size="1.25rem" />
          <span>Carregando ...</span>
        </q-item>

        <q-item
          v-else-if="comparationItems.length === 0"
          class="flex items-center py-0 px-16 h-40 border-t border-neutral-100/10 text-headline-3 text-neutral-40 !font-normal pointer-events-none"
        >
          <span>Nada encontrado.</span>
        </q-item>

        <template v-else>
          <q-item
            v-for="(_item, _index) in comparationItems"
            :key="_index"
            class="flex items-center py-0 px-16 h-40 border-t border-neutral-100/10 first:border-t-0 text-headline-3 text-neutral-70 !font-normal"
            clickable
            @click="handleAddComparison(_item)"
          >
            {{ _item.label }}
          </q-item>
        </template>
      </q-list>
    </q-menu>
  </OButton>
</template>

<script setup>
import { ref } from 'vue'
import OButton from 'components/Button/OButton.vue'
import OInput from 'components/Input/OInput.vue'
import useCopaReports from 'composables/useCopaReports'
import {
  comparationItems,
  filters,
  activeFilter,
  filtersLoading,
  filterModel,
} from 'store/copa.stores'
import { NotifySucess } from 'js/vue/boot/Notify'

const popup = ref(null)

const {
  search,
  loadItems,
  isFilterDisabled,
  addComparisonEvolution,
  addComparisonEvolutionBest,
} = useCopaReports()

const { type } = defineProps({
  type: {
    type: String,
    default: 'geral',
  },
})

async function handleAddComparison(item) {
  const success = await addComparisonEvolution(item)

  if (success) {
    NotifySucess('Comparação adicionada: ' + item.label)
  }

  popup.value.hide()
}

async function handleAddComparisonBest(bestType) {
  const comparation = await addComparisonEvolutionBest(bestType)

  if (comparation?.fabName) {
    NotifySucess('Comparação adicionada: ' + comparation.fabName)
  }

  popup.value.hide()
}
</script>

<style scoped lang="sass">
.q-field--float :deep(.q-field__label.no-pointer-events.absolute.ellipsis)
  display: none
</style>
